import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import EqualTimePoint from 'customer-data-filters-ui/filterQueryFormat/operator/EqualTimePoint';
import BeforeTimePoint from 'customer-data-filters-ui/filterQueryFormat/operator/BeforeTimePoint';
import AfterTimePoint from 'customer-data-filters-ui/filterQueryFormat/operator/AfterTimePoint';
import BetweenTimePoints from 'customer-data-filters-ui/filterQueryFormat/operator/BetweenTimePoints';
import NotBetweenTimePoints from 'customer-data-filters-ui/filterQueryFormat/operator/NotBetweenTimePoints';
import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import Less from 'customer-data-filters-ui/filterQueryFormat/operator/Less';
import Greater from 'customer-data-filters-ui/filterQueryFormat/operator/Greater';
import InRange from 'customer-data-filters-ui/filterQueryFormat/operator/InRange';
import AfterDateStaticOrDynamic from 'customer-data-filters-ui/filterQueryFormat/operator/AfterDateStaticOrDynamic';
import BeforeDateStaticOrDynamic from 'customer-data-filters-ui/filterQueryFormat/operator/BeforeDateStaticOrDynamic';
import { isValidDateWithoutYear } from '../operator/AnniversaryDateInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const leapYear = 2024;
export default function DisplayValueDate({
  value,
  operator,
  getIsUngated
}) {
  if (!value) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.DisplayValueDate.invalid"
    });
  }
  const getShowTimeFormat = () => {
    var _operator$field;
    const {
      hasTimezones
    } = operator;
    if (!hasRemoveTimezoneForDates(getIsUngated) || ((_operator$field = operator.field) === null || _operator$field === void 0 ? void 0 : _operator$field.type) !== DATE || operator.constructor !== EqualTimePoint && operator.constructor !== BeforeTimePoint && operator.constructor !== AfterTimePoint && operator.constructor !== BetweenTimePoints && operator.constructor !== NotBetweenTimePoints && operator.constructor !== Equal && operator.constructor !== Less && operator.constructor !== Greater && operator.constructor !== InRange && operator.constructor !== AfterDateStaticOrDynamic && operator.constructor !== BeforeDateStaticOrDynamic) {
      return true;
    }
    return !!hasTimezones;
  };
  const format = operator.ignoreYear ? 'MMM DD' : 'L';
  if (I18n.moment.isMoment(value)) {
    // FormattedDateTime component displays date in a portalTz so if a moment date
    // passed to it has a different TZ it will be converted. Since we need to display
    // a date in the filter's timezone we don't want this conversion to happen.
    // To prevent the conversion the value is manually switched to a portalTz
    // but without applying time offset between the timezones
    const valueWithPortalTz = value.clone()
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    .tz(I18n.moment.portalTz().tz(), true);
    const tzFormat = value.tz() || value.isUTC() ? 'z' : 'Z';
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedDateTime, {
        format: format,
        type: "portalTz",
        value: valueWithPortalTz
      }), getShowTimeFormat() && ` (${value.format(tzFormat)})`]
    });
  }
  const valueToDisplay = operator.ignoreYear && isValidDateWithoutYear(value) && value.month === 1 && value.date === 29 ? Object.assign({}, value, {
    year: leapYear
  }) : value;
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedDateTime, {
      format: format,
      type: "portalTz"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      value: I18n.moment.portalTz(valueToDisplay)
    }), getShowTimeFormat() && ` (${I18n.moment.portalTz().format('z')})`]
  });
}